import { DatePipe } from '@angular/common';
import { ArrayLimitToPipe } from '../../filters/array-limit-to.pipe';
import { StartFromPipe } from '../../filters/start-from.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemStatusComponent } from '../../components/item-status/item-status.component';
import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import ServiceRestServices from '../../services/service-rest.service';
import UserService from '../../services/user.service';
import CallStartService from '../../services/call-start.service';
import ChatService from '../../services/chat.service';
import ChatRestServices from '../../services/chat-rest.service';
import DialogServices from '../../services/dialog.service';
import Config from '../../utils/config.service';
import BookingsService from '../../services/bookings.service';
import StatusService from '../../services/status.service';
import InstantBookingService from '../../services/instant-booking.service';
import Session from '../../utils/session.service';
import Toast from '../../services/toast.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import ToolkitService from '../../services/toolkit.service';
import moment from 'moment';
import { Input, Output, EventEmitter } from '@angular/core';
import { ModalSymptomCheckInfoComponent } from '../modal-symptom-check-info/modal-symptom-check-info.component';
import { ModalPharmacyConsentsComponent } from '../modal-pharmacy-consents/modal-pharmacy-consents.component';
import { ModalBookingEnquiryComponent } from '../modal-booking-enquiry/modal-booking-enquiry.component';
import { ModalBookingDeclineComponent } from '../modal-booking-decline/modal-booking-decline.component';
import { ModalBookingInfoComponent } from '../modal-booking-info/modal-booking-info.component';
import { ModalSymptomCheckShareComponent } from '../modal-symptom-check-share/modal-symptom-check-share.component';
import { PanelDirective } from '../../directives/panel.directive';
import { Subscription } from 'rxjs';
import { GuideInfoPopoverComponent } from '../guide-info-popover/guide-info-popover.component';
import { ItemInfoPopoverComponent } from '../item-info-popover/item-info-popover.component';
import { ModalChatAvailabilityComponent } from '../modal-chat-availability/modal-chat-availability.component';
import { ModalBookingAddressComponent } from '../modal-booking-address/modal-booking-address.component';

@Component({
	standalone: true,
	selector: 'table-bookings',
	templateUrl: './table-bookings.component.html',
	styleUrls: ['./table-bookings.component.scss'],
	imports: [CommonModule, PanelDirective, DatePipe, ArrayLimitToPipe, StartFromPipe, TranslatePipe, ItemStatusComponent, FormsModule, GuideInfoPopoverComponent, ItemInfoPopoverComponent]
})
export class TableBookingsComponent implements OnInit, OnDestroy {
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private userService: UserService = inject(UserService);
	private callStartService: CallStartService = inject(CallStartService);
	private chatService: ChatService = inject(ChatService);
	private chatRestServices: ChatRestServices = inject(ChatRestServices);
	private dialogServices: DialogServices = inject(DialogServices);
	private config: Config = inject(Config);
	private bookingsService: BookingsService = inject(BookingsService);
	private statusService: StatusService = inject(StatusService);
	private instantBookingService: InstantBookingService = inject(InstantBookingService);
	private session: Session = inject(Session);
	private toast: Toast = inject(Toast);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private toolkitService: ToolkitService = inject(ToolkitService);
	
	@Input() pageSize: any | undefined;
	@Input() bookings: any;
	@Input() currentPage: any | undefined;
	@Output() currentPageChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	@Input() status: any | undefined;
	
	vm: any = undefined;
	watcher: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	isHovered: any = {};
	isMobile: boolean;
	notValidForChatting: boolean;

	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.user = this.session.getSession().user;
		this.vm.isDoctor = !!(this.vm.user.businessUserType === 'SERVICE_PROVIDER');
		if (this.vm.isDoctor) this.getService();
		this.vm.pageSize = this.vm.pageSize || 10;
		this.vm.currentPage = this.vm.currentPage || 0;
		this.vm.charLimit = 100;
		this.vm.mobileBreakpoint = 768;
		this.handleParamsUpdate();
		this.vm.toolkitClientsById = {};
		this.vm.toolkitAssessmentAssignments = [];
		if (this.vm.isDoctor && this.hasPrepColumn()) this.loadToolkitPrepContext();
		this.angularHelperService.element(this.angularHelperService.getWindow()).on('resize', () => { this.handleParamsUpdate(); });

		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, this.config.getBroadcastConfig().Notifications.COUNT,
				(e, data) => {
					this.handleNewMessages(data);
				}
			)
		);
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, this.config.getBroadcastConfig().Bookings.INITIALIZED,
				(e, data) => {
					var chats: any = this.chatService.getChats();
					if (!chats) return;
					var unreadChats: any = this.angularFilterHelperService.unreadChats(chats);
					this.handleNewMessages(unreadChats);
				}
			)
		);

		var currentStatuses = [];
		var currentBookingsCount = this.vm.bookings.length;
		this.watcher = this.angularHelperService.createInterval(() => {
			var newStatuses = this.statusService.getStatuses();
			if (!this.angularHelperService.isEqual(newStatuses, currentStatuses)) {
				console.log("Statuses updated", currentStatuses, newStatuses);
				currentStatuses = newStatuses;
				this.handleStatusUpdates(newStatuses);
			}
			
			var newBookingsCount = this.vm.bookings.length;
			if (newBookingsCount !== currentBookingsCount) {
				currentBookingsCount = newBookingsCount;
				if (currentBookingsCount > 0) {
					this.handleIBTimerInit();
				}
				if (this.vm.isDoctor && this.hasPrepColumn()) this.loadToolkitPrepContext();
				if (this.vm.status !== 'CONFIRMED') return;
				this.addUsersToWatchlist();
				this.handleStatusUpdates(this.statusService.getStatuses());
			}
			
		}, 300);
		
		this.vm.confirmBooking = this.confirmBooking;
		this.vm.declineBooking = this.declineBooking;
		this.vm.goToPharmacy = this.goToPharmacy;
		this.vm.isPrescriptionValidForBuying = this.isPrescriptionValidForBuying;
		this.vm.openBookingInfo = this.openBookingInfo;
		this.vm.openSymptomCheckInfo = this.openSymptomCheckInfo;
		this.vm.openSymptomCheckShare = this.openSymptomCheckShare;
		this.vm.openChat = this.openChat;
		this.vm.isChatButtonDisabled = this.isChatButtonDisabled;
		this.vm.onChatButtonHover = this.onChatButtonHover;
		this.vm.onChatButtonLeave = this.onChatButtonLeave;
		this.vm.getHoverMessageCode = this.getHoverMessageCode;
		this.vm.call = this.call;
		this.vm.clickReservationLink = this.clickReservationLink;
		this.vm.getPrescriptionDescription = this.getPrescriptionDescription;
		this.vm.displayTherapyFundNotesToast = this.displayTherapyFundNotesToast;
		this.vm.bookAgain = this.bookAgain;
		this.vm.isCancelAllowed = this.isCancelAllowed;
		this.vm.cancelBooking = this.cancelBooking;
		this.vm.bookingStatusLabel = this.bookingStatusLabel.bind(this);
		this.vm.sessionChipLabel = this.sessionChipLabel.bind(this);
		this.vm.hasSessionColumn = this.hasSessionColumn.bind(this);
		this.vm.hasPrepColumn = this.hasPrepColumn.bind(this);
		this.vm.showPrepHeader = this.showPrepHeader.bind(this);
		this.vm.showDescriptionHeader = this.showDescriptionHeader.bind(this);
		this.vm.showDescriptionForBooking = this.showDescriptionForBooking.bind(this);
		this.vm.showPrepCellForBooking = this.showPrepCellForBooking.bind(this);
		this.vm.showPrepForBooking = this.showPrepForBooking.bind(this);
		this.vm.hasPrepPrompt = this.hasPrepPrompt.bind(this);
		this.vm.prepChipLabel = this.prepChipLabel.bind(this);
		this.vm.prepChipStyle = this.prepChipStyle.bind(this);
		this.vm.prepSummary = this.prepSummary.bind(this);
		this.vm.prepActionLabel = this.prepActionLabel.bind(this);
		this.vm.isPrepActionPrimary = this.isPrepActionPrimary.bind(this);
		this.vm.openPrepAction = this.openPrepAction.bind(this);
		
		this.vm.setStatus = this.statusService.setStatus;
	}
	
	ngOnDestroy() {
		this.handleIBTimerDestroy();
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	handleIBTimerInit() {
		this.handleIBTimerDestroy();
		if (!this.vm.bookings || this.vm.status !== 'CONFIRMED') return;
		var hasInstantRequests: any = this.vm.bookings
			.filter((item) => { return typeof item.chatOnly !== 'undefined'; }).length > 0;
		if (!hasInstantRequests) return;
		
		this.handleIBTimerUpdate();
		this.vm.timerInterval = this.angularHelperService.createInterval(this.handleIBTimerUpdate, 1000);
	}
	
	handleIBTimerUpdate() {
		var currentDate: any = moment();
		
		this.vm.bookings.forEach((booking) => {
			booking.isInstant = typeof booking.chatOnly !== 'undefined';
			if (!booking.isInstant) return;
			this.instantBookingService.calculateTimeLeft(booking, currentDate);
		});
	}
	
	handleIBTimerDestroy() {
		if (this.vm.timerInterval) this.angularHelperService.cancelInterval(this.vm.timerInterval);
	}
	
	addUsersToWatchlist() {
		if (!this.vm.isDoctor) return;
		
		var users: any = this.vm.bookings
			.map(function(booking) { return booking.user.id; })
			.filter(function(v, i, self) { return self.indexOf(v) === i; })
			.map(function(id) { return { id: id }; });
		
		this.statusService.addUsers(users);
	}
	
	getPrescriptionDescription(booking) {
		if (booking.bookingInstantRequest.prescriptionRequest.prescription) {
			var drugName: any = booking.bookingInstantRequest.prescriptionRequest.prescription.drugName
				|| booking.bookingInstantRequest.prescriptionRequest.prescription.ingredientName;
			return booking.bookingInstantRequest.prescriptionRequest.prescription.prescriptionNumber + ', ' + drugName;
		}
		return (booking.bookingInstantRequest.prescriptionRequest.drug
				&& booking.bookingInstantRequest.prescriptionRequest.drug.name)
			? (booking.bookingInstantRequest.prescriptionRequest.drug.name + ' ' + booking.bookingInstantRequest.prescriptionRequest.drug.amount)
			: booking.bookingInstantRequest.prescriptionRequest.drugIngredient.name;
	}
	
	isCancelAllowed(booking) {
		return (moment(booking.scheduledStart).diff(moment(), 'hours', true) >= 24);
	}
	
	cancelBooking(booking) {
		if (!this.vm.isCancelAllowed) return;
		var dialog = this.dialogServices.confirmation({
			title: this.angularFilterHelperService.translate('Modal.Title.Confirm'),
			content: this.angularFilterHelperService.translate('Services.Other.Confirm_Cancel'),
		});
		dialog.afterClosed().subscribe((data) => {
			if (data) {
				this.serviceRestServices.declineBookingForBU({ id: booking.id }, () => {
					this.userService.clearWalletCache();
					this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Services.BOOKING_CANCELLED, { id: booking.id });
					this.angularHelperService.getWindow().location.reload();
				});
			}
		});
	}
	
	goToPharmacy(booking) {
		if (!booking) return;
		this.dialogServices.show({
			controller: ModalPharmacyConsentsComponent,
			booking: booking,
			clickOutsideToClose: false,
			escapeToClose: false,
			multiple: false,
		});
	}
	
	isPrescriptionValidForBuying(booking) {
		if (booking.bookingInstantRequest?.prescriptionRequest?.id) {
			if (!this.config.getPharmacyConfig().PURCHASING_SUPPORTED) {
				return false;
			}
			if (booking.bookingInstantRequest
				&& booking.bookingInstantRequest.prescriptionRequest
				&& booking.bookingInstantRequest.prescriptionRequest.prescriptionNumber) {
				return (moment(booking.scheduledStart).diff(moment(), 'hours', true) >= -240); // 10 days or 240 hours
			} else {
				return false;
			}
		}
		return false;
	}
	
	handleStatusUpdates(statuses) {
		if (!this.vm.isDoctor) return;
		
		this.angularHelperService.forEach(this.vm.bookings, (booking) => {
			if (!booking.user || !booking.user.id) return;
			if (statuses[booking.user.id]) booking.user.status = statuses[booking.user.id].status;
		});
	}
	
	handleNewMessages(chats) {
		if (!this.vm.bookings || !this.vm.bookings.length) return;
		this.vm.bookings.map((booking) => {
			var user: any = this.vm.isDoctor ? booking.user : booking.service.user;
			var hasNew: any = false;
			this.angularHelperService.forEach(chats, (chat) => {
				if (chat.privateChatFriend.id === user.id) hasNew = true;
			});
			booking.hasNewMessages = hasNew;
		});
	}
	
	openBookingInfo(booking, showPrescription) {
		if (!booking) return;
		this.dialogServices.show({
			controller: ModalBookingInfoComponent,
			booking: booking,
			showPrescription: showPrescription
		});
	}
	displayTherapyFundNotesToast() {
		this.toast.showWithTranslation('TherapyFundWallet.Notes_Required');
	}
	
	openSymptomCheckInfo(interviewId) {
		if (!interviewId) return;
		this.dialogServices.show({
			controller: ModalSymptomCheckInfoComponent,
			interviewId: interviewId, 
			preVisitTicketId: undefined
		});
	}
	
	openSymptomCheckShare(booking) {
		if (!booking || !booking.symptomCheck || this.vm.isDoctor) return;
		this.dialogServices.show({
			controller: ModalSymptomCheckShareComponent,
			booking: booking
		});
	}
	
	bookAgain(booking) {
		this.serviceRestServices.getServiceById({ id: booking.service.id }, (service) => {
			if (service.nextAvailableTime) {
				this.openBookingView(service);
			} else {
				this.openBookingEnquiry(service);
			}
		});
	}

	bookingStatusLabel(booking) {
		const status = (booking?.status || '').toString().toUpperCase();
		if (this.vm?.status === 'CONFIRMED' && ['AWAITING_CLIENT', 'AWAITING_CUSTOMER'].includes(status)) {
			return '';
		}
		return this.angularFilterHelperService.translate('Calendar.Modal.' + booking.status);
	}

	sessionChipLabel(booking) {
		const index = this.bookingSessionIndex(booking);
		return isFinite(index) && index > 0
			? `${this.angularFilterHelperService.translate('Booking.Session_Number')} ${index}`
			: '';
	}

	hasSessionColumn() {
		const status = (this.vm?.status || '').toString().toUpperCase();
		return !!(this.vm?.isDoctor && (status === 'CONFIRMED' || status === 'UPCOMING'));
	}

	hasPrepColumn() {
		const status = (this.vm?.status || '').toString().toUpperCase();
		return !!(this.vm?.isDoctor && (status === 'CONFIRMED' || status === 'UPCOMING'));
	}

	showPrepHeader() {
		if (!this.hasPrepColumn()) return false;
		return (this.vm?.bookings || []).some((booking) => this.isPrepEligibleSession(booking) || this.showPrepForBooking(booking));
	}

	showDescriptionHeader() {
		if (!this.hasPrepColumn()) return true;
		return (this.vm?.bookings || []).some((booking) => this.showDescriptionForBooking(booking));
	}

	showDescriptionForBooking(booking) {
		return true;
	}

	showPrepCellForBooking(booking) {
		return this.showPrepHeader();
	}

	showPrepForBooking(booking) {
		if (!this.hasPrepColumn()) return false;
		if (!this.isPrepEligibleSession(booking)) return false;
		const state = this.getPrepPromptState(booking);
		return ['due', 'sent', 'overdue', 'completed'].includes(state);
	}

	hasPrepPrompt(booking) {
		return this.showPrepForBooking(booking) && !!this.prepChipLabel(booking);
	}

	prepChipLabel(booking) {
		const state = this.getPrepPromptState(booking);
		if (state === 'due') return this.angularFilterHelperService.translate('Toolkit.Prep.Status.Due');
		if (state === 'sent') return this.angularFilterHelperService.translate('Toolkit.Prep.Status.Sent');
		if (state === 'overdue') return this.angularFilterHelperService.translate('Toolkit.Prep.Status.Overdue');
		if (state === 'completed') return this.angularFilterHelperService.translate('Toolkit.Prep.Status.Completed');
		return '';
	}

	prepChipStyle(booking) {
		const state = this.getPrepPromptState(booking);
		if (state === 'due') return { background: '#fff7e8', color: '#8a5a00' };
		if (state === 'sent') return { background: '#e8f0fe', color: '#2549c4' };
		if (state === 'completed') return { background: '#e8f7ee', color: '#1e9e5a' };
		return { background: '#fdeceb', color: '#d0453b' };
	}

	prepSummary(booking) {
		const prompt = this.getEffectivePrepPrompt(booking);
		if (!prompt) return '—';
		const state = (prompt.state || '').toString().toLowerCase();
		if (state === 'due') {
			const baselineDate = prompt?.baselineAt ? this.formatShortDate(prompt.baselineAt) : '';
			if (baselineDate && prompt?.baselineScore != null) {
				return this.angularFilterHelperService.stringBuilder(
					this.angularFilterHelperService.translate('Toolkit.Prep.Summary.Due.WithBaselineDate'),
					baselineDate,
					prompt.baselineScore
				);
			}
			if (prompt?.baselineScore != null) {
				return this.angularFilterHelperService.stringBuilder(
					this.angularFilterHelperService.translate('Toolkit.Prep.Summary.Due.WithBaselineScore'),
					prompt.baselineScore
				);
			}
			return this.angularFilterHelperService.translate('Toolkit.Prep.Summary.Due.Default');
		}
		if (state === 'sent') {
			const sentAt = prompt?.sentAt || prompt?.assignedAt || prompt?.createdAt || prompt?.updatedAt || null;
			const due = prompt?.dueAt ? this.formatShortDate(prompt.dueAt) : '';
			const sent = sentAt ? this.formatShortDate(sentAt) : '';
			if (sent && due) {
				return this.angularFilterHelperService.stringBuilder(
					this.angularFilterHelperService.translate('Toolkit.Prep.Summary.Sent.WithSentAndDue'),
					sent,
					due
				);
			}
			if (sent) {
				return this.angularFilterHelperService.stringBuilder(
					this.angularFilterHelperService.translate('Toolkit.Prep.Summary.Sent.WithSent'),
					sent
				);
			}
			if (due) {
				return this.angularFilterHelperService.stringBuilder(
					this.angularFilterHelperService.translate('Toolkit.Prep.Summary.Sent.WithDue'),
					due
				);
			}
			return this.angularFilterHelperService.translate('Toolkit.Prep.Summary.Sent.Default');
		}
		if (state === 'overdue') {
			return prompt?.dueAt
				? this.angularFilterHelperService.stringBuilder(
					this.angularFilterHelperService.translate('Toolkit.Prep.Summary.Overdue.WithDue'),
					this.formatShortDate(prompt.dueAt)
				)
				: this.angularFilterHelperService.translate('Toolkit.Prep.Summary.Overdue.Default');
		}
		if (state === 'completed') {
			const delta = prompt?.deltaFromBaseline;
			if (delta == null) {
				return this.angularFilterHelperService.stringBuilder(
					this.angularFilterHelperService.translate('Toolkit.Prep.Summary.Completed.WithoutDelta'),
					prompt?.score ?? '-'
				);
			}
			const deltaText = delta < 0 ? '▼' + Math.abs(delta) : '▲' + delta;
			return this.angularFilterHelperService.stringBuilder(
				this.angularFilterHelperService.translate('Toolkit.Prep.Summary.Completed.WithDelta'),
				prompt?.score ?? '-',
				deltaText
			);
		}
		return '—';
	}

	prepActionLabel(booking) {
		const state = this.getPrepPromptState(booking);
		if (state === 'due') return this.angularFilterHelperService.translate('Toolkit.Prep.Action.Assign');
		if (state === 'sent' || state === 'overdue') return this.angularFilterHelperService.translate('Toolkit.Prep.Action.Remind');
		if (state === 'completed') return this.angularFilterHelperService.translate('Toolkit.Prep.Action.ViewResult');
		return '';
	}

	isPrepActionPrimary(booking) {
		return this.getPrepPromptState(booking) === 'due';
	}

	openPrepAction(booking) {
		const prompt = this.getEffectivePrepPrompt(booking);
		if (!prompt) return;
		const state = (prompt.state || '').toString().toLowerCase();
		const clientId = booking?.user?.id;
		if (!clientId) return;
		if (state === 'due') {
			this.angularRoutingHelperService.setPath(['/toolkit/assessment/assign', prompt.assessmentId || 'eek2'], false, false, {
				clientId,
				timepoint: prompt.timepoint,
				bookingId: booking?.id,
				source: 'prompt'
			});
			return;
		}
		if (state === 'completed' && prompt?.assignmentId) {
			this.angularRoutingHelperService.setPath(['/toolkit/assessment/preview', prompt.assessmentId || 'eek2'], false, false, {
				preview: 1,
				client_id: clientId,
				assignment_id: prompt.assignmentId,
				return_to: '/bookings/upcoming'
			});
			return;
		}
		this.openChat(booking);
	}

	private getPrepPromptState(booking: any): string {
		return (this.getEffectivePrepPrompt(booking)?.state || '').toString().toLowerCase();
	}

	private isPrepEligibleSession(booking: any): boolean {
		const sessionIndex = this.bookingSessionIndex(booking);
		if (!isFinite(sessionIndex)) return false;
		return sessionIndex >= 4;
	}

	private bookingSessionIndex(booking: any): number {
		const prompt = this.getEffectivePrepPrompt(booking);
		const index = Number(
			booking?.sessionIndex
			?? booking?.sessionNumber
			?? booking?.sessionNo
			?? booking?.nextBooking?.sessionIndex
			?? prompt?.sessionIndex
			?? booking?.nextSessionIndex
			?? booking?.user?.nextSessionIndex
			?? booking?.user?.nextBooking?.sessionIndex
			?? 0
		);
		return isFinite(index) ? index : 0;
	}

	private getEffectivePrepPrompt(booking: any): any | null {
		const clientPrompt = this.getToolkitClientEffectivePrompt(booking);
		if (clientPrompt) return clientPrompt;

		const prompt = this.findPrepPromptCandidate(booking);
		if (!prompt) return null;

		const sessionIndex = prompt?.sessionIndex ?? booking?.sessionIndex ?? booking?.nextBooking?.sessionIndex ?? booking?.nextSessionIndex ?? null;
		const effective = {
			...prompt,
			assessmentId: prompt?.assessmentId || booking?.assessmentId || 'eek2',
			assignmentId: prompt?.assignmentId ?? prompt?.id ?? booking?.assignmentId ?? null,
			sessionIndex,
			timepoint: prompt?.timepoint || this.sessionIndexToTimepoint(sessionIndex),
			assignedAt: prompt?.assignedAt || prompt?.created || prompt?.createdAt || booking?.assignedAt || null,
			sentAt: prompt?.sentAt || prompt?.assignedAt || prompt?.created || prompt?.createdAt || booking?.sentAt || booking?.assignedAt || null,
			dueAt: prompt?.dueAt || booking?.dueAt || null,
			score: prompt?.score ?? booking?.score ?? null,
			completedAt: prompt?.completedAt || booking?.completedAt || null
		};

		const rawState = (prompt?.state || prompt?.status || '').toString().toLowerCase();
		if (rawState === 'completed' || !!effective.completedAt) {
			effective.state = 'completed';
			return effective;
		}
		if (rawState === 'overdue' || this.isOverdue(effective.dueAt)) {
			effective.state = 'overdue';
			return effective;
		}
		if (rawState === 'due') {
			effective.state = 'due';
			return effective;
		}
		if (rawState === 'sent' || effective.sentAt || effective.assignmentId) {
			effective.state = 'sent';
			return effective;
		}
		return null;
	}

	private getToolkitClientEffectivePrompt(booking: any): any | null {
		const clientId = (booking?.user?.id ?? '').toString();
		if (!clientId) return null;

		const client = this.vm?.toolkitClientsById?.[clientId];
		const prompt = client?.assessmentPrompt || null;
		if (!prompt) return null;

		const assignment = this.findToolkitPromptAssignment(client);
		if (!assignment) return this.normalizePrepPrompt(prompt, booking, client);

		const normalized = this.normalizePrepPrompt({
			...prompt,
			assignmentId: assignment?.id ?? prompt?.assignmentId ?? null,
			timepoint: assignment?.timepoint || prompt?.timepoint || this.promptTimepoint(client, prompt),
			sessionIndex: assignment?.sessionIndex ?? prompt?.sessionIndex ?? client?.nextBooking?.sessionIndex ?? client?.nextSessionIndex ?? booking?.sessionIndex ?? null,
			assignedAt: assignment?.assignedAt || assignment?.created || prompt?.assignedAt || null,
			sentAt: assignment?.assignedAt || assignment?.created || prompt?.sentAt || prompt?.assignedAt || null,
			dueAt: assignment?.dueAt || prompt?.dueAt || null,
			score: assignment?.score ?? prompt?.score ?? null,
			completedAt: assignment?.completedAt || prompt?.completedAt || null,
			state: prompt?.state
		}, booking, client);

		const assignmentStatus = (assignment?.status || '').toString().toLowerCase();
		if (assignment?.completedAt || assignmentStatus === 'completed') {
			normalized.state = 'completed';
			return normalized;
		}
		if (this.isOverdue(assignment?.dueAt)) {
			normalized.state = 'overdue';
			return normalized;
		}
		normalized.state = 'sent';
		return normalized;
	}

	private findPrepPromptCandidate(booking: any): any | null {
		const directCandidates = [
			booking?.assessmentPrompt,
			booking?.assessmentAssignment,
			booking?.currentAssessmentAssignment,
			booking?.nextAssessmentAssignment,
			booking?.assessment,
			booking?.eek2,
			booking?.eek2Prompt,
			booking?.eek2Assessment,
			booking?.user?.assessmentPrompt
		];
		for (const candidate of directCandidates) {
			if (this.isPrepPromptCandidate(candidate)) return candidate;
		}

		const listCandidates = [
			booking?.assessmentAssignments,
			booking?.assessmentPrompts,
			booking?.user?.assessmentAssignments
		];
		for (const list of listCandidates) {
			if (!Array.isArray(list)) continue;
			const match = list.find((item) => this.isPrepPromptCandidate(item));
			if (match) return match;
		}

		return null;
	}

	private normalizePrepPrompt(prompt: any, booking?: any, client?: any): any | null {
		if (!prompt) return null;
		const sessionIndex =
			prompt?.sessionIndex
			?? booking?.sessionIndex
			?? client?.nextBooking?.sessionIndex
			?? client?.nextSessionIndex
			?? booking?.nextBooking?.sessionIndex
			?? booking?.nextSessionIndex
			?? null;
		const effective = {
			...prompt,
			assessmentId: prompt?.assessmentId || booking?.assessmentId || 'eek2',
			assignmentId: prompt?.assignmentId ?? prompt?.id ?? booking?.assignmentId ?? null,
			sessionIndex,
			timepoint: prompt?.timepoint || this.promptTimepoint(client || booking, prompt) || this.sessionIndexToTimepoint(sessionIndex),
			assignedAt: prompt?.assignedAt || prompt?.created || prompt?.createdAt || booking?.assignedAt || null,
			sentAt: prompt?.sentAt || prompt?.assignedAt || prompt?.created || prompt?.createdAt || booking?.sentAt || booking?.assignedAt || null,
			dueAt: prompt?.dueAt || booking?.dueAt || null,
			score: prompt?.score ?? booking?.score ?? null,
			completedAt: prompt?.completedAt || booking?.completedAt || null
		};

		const rawState = (prompt?.state || prompt?.status || '').toString().toLowerCase();
		if (rawState === 'completed' || !!effective.completedAt) {
			effective.state = 'completed';
			return effective;
		}
		if (rawState === 'overdue' || this.isOverdue(effective.dueAt)) {
			effective.state = 'overdue';
			return effective;
		}
		if (rawState === 'due') {
			effective.state = 'due';
			return effective;
		}
		if (rawState === 'sent' || effective.sentAt || effective.assignmentId) {
			effective.state = 'sent';
			return effective;
		}
		return null;
	}

	private isPrepPromptCandidate(candidate: any): boolean {
		if (!candidate || typeof candidate !== 'object') return false;
		const state = (candidate?.state || candidate?.status || '').toString().toLowerCase();
		return ['due', 'sent', 'overdue', 'completed'].includes(state)
			|| !!candidate?.dueAt
			|| !!candidate?.completedAt
			|| !!candidate?.sentAt
			|| !!candidate?.assignedAt
			|| candidate?.assignmentId != null
			|| candidate?.assessmentId != null;
	}

	private sessionIndexToTimepoint(sessionIndex: any): string | null {
		const numeric = Number(sessionIndex || 0);
		if (!isFinite(numeric)) return null;
		if (numeric === 1) return 'T1_BASELINE';
		if (numeric === 4 || numeric === 5) return 'T2';
		if (numeric === 8 || numeric === 9) return 'T3';
		if (numeric >= 4) return 'AD_HOC';
		return null;
	}

	private isOverdue(dueAt: any): boolean {
		if (!dueAt) return false;
		const d = new Date(dueAt);
		return isFinite(d.getTime()) && d.getTime() < Date.now();
	}

	private loadToolkitPrepContext() {
		this.toolkitService.getUserCustomers({}, (clients) => {
			const byId = {};
			(clients || []).forEach((client) => {
				const id = (client?.id ?? client?.clientId ?? client?.userId ?? '').toString();
				if (id) byId[id] = client;
			});
			this.vm.toolkitClientsById = byId;
		});

		this.toolkitService.getAssessmentAssignments({}, (items) => {
			this.vm.toolkitAssessmentAssignments = Array.isArray(items) ? items : [];
		});
	}

	private promptTimepoint(client: any, prompt?: any): string | null {
		if (!client && !prompt) return null;
		return (
			prompt?.timepoint
			|| client?.planProgress?.dueTimepoint
			|| this.sessionIndexToTimepoint(prompt?.sessionIndex ?? client?.nextBooking?.sessionIndex ?? client?.nextSessionIndex ?? client?.sessionIndex)
		);
	}

	private findToolkitPromptAssignment(client: any): any | null {
		const clientId = (client?.id ?? client?.clientId ?? client?.userId ?? '').toString();
		const prompt = client?.assessmentPrompt || null;
		if (!clientId || !prompt) return null;

		const targetAssessmentId = (prompt?.assessmentId || 'eek2').toString();
		const targetTimepoint = this.promptTimepoint(client, prompt);
		const surveys: any[] = Array.isArray(this.vm?.toolkitAssessmentAssignments) ? this.vm.toolkitAssessmentAssignments : [];

		const matches = surveys
			.filter((assignment) => {
				if (!assignment || assignment?.isDeleted) return false;
				if ((assignment?.clientUserId ?? assignment?.clientId ?? assignment?.userId ?? '').toString() !== clientId) return false;
				if ((assignment?.assessmentId || '').toString() !== targetAssessmentId) return false;
				if (targetTimepoint) {
					const assignmentTimepoint = (assignment?.timepoint || this.sessionIndexToTimepoint(assignment?.sessionIndex) || '').toString().toUpperCase();
					if (assignmentTimepoint !== targetTimepoint.toString().toUpperCase()) return false;
				}
				return true;
			})
			.sort((a, b) => {
				const at = new Date(a?.completedAt || a?.assignedAt || a?.created || a?.updatedAt || 0).getTime();
				const bt = new Date(b?.completedAt || b?.assignedAt || b?.created || b?.updatedAt || 0).getTime();
				return bt - at;
			});

		return matches[0] || null;
	}

	private formatShortDate(value: any): string {
		if (!value) return '';
		const d = new Date(value);
		if (!isFinite(d.getTime())) return '';
		const rawLocale = (this.vm?.user?.deviceLanguage || this.vm?.user?.language || '').toString().trim() || undefined;
		const locale = rawLocale ? rawLocale.replace('_', '-') : undefined;
		return d.toLocaleDateString(locale, { day: '2-digit', month: 'short' });
	}
	
	openBookingEnquiry(service) {
		this.dialogServices.show({
			controller: ModalBookingEnquiryComponent,
			service: service
		});
	}
	
	openBookingView(service) {
		this.angularRoutingHelperService.setPath(["booking/service/", service.id]);
	}

	confirmBooking(booking) {
		if (!booking || booking && booking.handleInProgress) return;
		booking.handleInProgress = true;

		if (booking.communicationType === 'FACE_TO_FACE') {
			const dialog = this.dialogServices.show({
				controller: ModalBookingAddressComponent,
				booking: booking
			});

			dialog.afterClosed().subscribe((data) => {
				if (data) {
					this.bookingsService.confirm(booking);
					booking.handleInProgress = false;
				}
			});

			return;
		}

		this.bookingsService.confirm(booking);
		booking.handleInProgress = false;
	}

	declineBooking(booking) {
		if (!booking || booking && booking.handleInProgress) return;
		booking.handleInProgress = true;
		this.dialogServices.show({
			controller: ModalBookingDeclineComponent,
			booking: booking
		});
	}
	
	call(booking) {
		if (!this.vm.isDoctor) return;
		if (!booking || booking && booking.callInitInProgress) return;
		if (booking.communicationType === 'CHAT'
			|| booking.communicationType === 'PHONE'
			|| booking.communicationType === 'NONE'
			|| booking.service.subcategory === 'HOME_VISITS') return;
		booking.callInitInProgress = true;
		this.callStartService.startBusinessCall(booking.user.id, booking.id);
		this.angularHelperService.createTimer(function() { booking.callInitInProgress = false; }, 500);
	}
	
	clickReservationLink(booking) {
		if (this.vm.isDoctor) {
			// create temp element
			var copyElement: any = document.createElement("span");
			copyElement.appendChild(document.createTextNode(booking.reservationLink));
			copyElement.id = 'tempCopyToClipboard';
			this.angularHelperService.element(document.body.append(copyElement));
			
			// select the text
			var range: any = document.createRange();
			range.selectNode(copyElement);
			var _window: any = window;
			_window.getSelection().removeAllRanges();
			_window.getSelection().addRange(range);
			
			// copy & cleanup
			document.execCommand('copy');
			_window.getSelection().removeAllRanges();
			copyElement.remove();
		} else {
			this.angularRoutingHelperService.setPath(['booking/', booking.id, 'reservation']);
		}
		
	}

	onChatButtonHover(id: string) {
		this.isHovered[id] = true;
	}

	onChatButtonLeave(id: string) {
		setTimeout(() => {
			this.isHovered[id] = false;
		}, 100); // Adjust the delay as needed
	}

	getHoverMessageCode(booking: any): string {
		if (booking.status === 'PAYED') {
			return 'Booking.Title.Chat_Unavailable';
		}
		return 'Booking.Title.Chat_Unavailable_For_Completed';
	}

	isChatButtonDisabled(booking: any): boolean {
		if (this.vm.isDoctor) {
			return !booking || booking && !booking.user;
		} else {
			this.notValidForChatting = booking.validForChatting !== true;
			return this.vm.isMobile ? false : this.notValidForChatting;
		}
	}

	openChat(booking) {
		if (this.isChatButtonDisabled(booking)) return;
		if (this.notValidForChatting === true && this.vm.isMobile) {
			this.toast.showAsync(this.angularFilterHelperService.translate(this.vm.getHoverMessageCode(booking)));
			return;
		}
		var user: any = this.vm.isDoctor ? booking.user : booking.service.user;
		this.chatRestServices.getChatByFriendId({ friendUserId: user.id }, (chat) => {
			this.chatService.openChatById(user, chat.id);
		});
	}

	checkChatAvailability(booking) {
		if (this.vm.chatAvailabilityChecking) return;
		this.vm.chatAvailabilityChecking = true;
		this.chatRestServices.getExtraInfo({
			userId: booking.user.id
		}).then((extraInfo) => {
			booking.extraInfo = extraInfo;
			this.dialogServices.show({
				controller: ModalChatAvailabilityComponent,
				extraInfo: booking.extraInfo,
				user: booking.user
			});
			this.vm.chatAvailabilityChecking = false;
		}).catch((error) => {
			console.log(error);
			this.vm.chatAvailabilityChecking = false;
		});
	}

	getService() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		this.serviceRestServices.getServiceByUserId({ userId: this.vm.user.id }, (service) => {
			this.vm.showPrescriptionButton = this.vm.isDoctor && service.subcategory != 'PSYCHOLOGY' && service.weightLossServiceSupported;
			deferred.resolve();
		}, () => {
			deferred.reject();
		});
		return deferred.promise;
	}

	handleParamsUpdate() {
        this.vm.isMobile = window.innerWidth < this.vm.mobileBreakpoint;
    }
}
